import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getOrderFailed } from "../Services/Service";
import { Backdrop } from "@mui/material";
import Spinner from "./Spinner";
function Failed() {
  const [orderDetails, setOrderDetails] = useState({
    price: 0,
    txnId: 0,
    accessoriesOrdersId: 0,
    payment_module_code: 0,
  });
  const [time, setTime] = useState(true);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const order_id = queryParams.get("order_id");
  let navigate = useNavigate();
  useEffect(() => {
    const failedOrder = async (order_id) => {
      const { data } = await getOrderFailed(order_id);
      console.log(data);
      setOrderDetails(data?.data);
      setTime(false);
      if (data?.data?.status === "1") {
        navigate(`/track?order_id=${order_id}`);
      }
    };
    failedOrder(order_id);
  }, [order_id]);
  const GoToHome = () => {
    navigate("/cart");
  };
  return (
    <div>
      <Backdrop open={time}>
        <Spinner />
      </Backdrop>
      {!time && (
        <section className="payment-success-bg py-5 mt-5 mb-5">
          <div className="container px-3">
            <div className="row justify-content-center text-center">
              <div className="col-12 col-md-10 col-lg-8">
                <img
                  src="https://store.icespice.com/assets/images/img-failed.png"
                  alt="Payment Failed"
                  className="img-fluid mb-4"
                  style={{ maxWidth: "160px" }}
                />

                <h1 className="heading-failed fs-4 fs-md-3 mb-2">
                  Payment Failed
                </h1>
                <h2 className="subheading fs-6 text-muted mb-4">
                  It seems the transaction failed.
                </h2>

                <p className="mb-2">
                  <strong>Order ID:</strong>{" "}
                  <span className="text-muted">
                    {orderDetails?.accessoriesOrdersId || "#"}
                  </span>
                </p>

                <p className="mb-2">
                  <strong>Amount:</strong>{" "}
                  <span className="text-success fw-bold fs-5">
                    ₹ {orderDetails?.price || ""}
                  </span>
                </p>

                <p className="mb-3">
                  <strong>Payment ID:</strong>{" "}
                  <span className="text-muted">
                    {orderDetails?.payment_module_code || ""}
                  </span>
                </p>

                <button
                  className="btn btnPrimary w-100 w-md-50 mt-2"
                  onClick={GoToHome}
                >
                  Go to Cart
                </button>

                <div className="mt-4 p-3 bg-light rounded">
                  <p className="mb-1 small">
                    If amount is deducted from your account, please contact our
                    customer support.
                  </p>
                  <p className="small mb-0">
                    Email:&nbsp;
                    <a
                      href="mailto:support@icespice.com"
                      className="text-decoration-underline text-dark"
                    >
                      support@icespice.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
}

export default Failed;
